import React from "react";
import { Link } from "react-router-dom";
import heroImg from "../Assests/Image2.jpg";
import harvestImg from "../Assests/Image1.jpg";
import whiteRiceImg from "../Assests/Image3.jpg";
import redRiceImg from "../Assests/Image4.jpg";
import qaImg from "../Assests/Image5.jpg";
import packImg from "../Assests/Image6.jpg";

const ranges = [
  {
    title: "Samba & Nadu",
    detail: "Staple grains tuned for Sri Lankan kitchens - fluffy, soft, and dependable.",
    specs: ["Red & white variants", "Broken <= 5%", "5kg | 10kg | 25kg bags"],
  },
  {
    title: "Keeri Samba / Basmati",
    detail: "Aromatic rice for biriyani, fried rice, and special menus that need fragrance.",
    specs: ["Aromatic polish", "Moisture <= 13%", "Export-ready packing"],
  },
  {
    title: "Red Raw & Red Samba",
    detail: "Nutrient-rich, unpolished grains for wellness menus and Ayurvedic kitchens.",
    specs: ["High fiber", "Low husk count", "Retail and bulk packs"],
  },
  {
    title: "Parboiled / Steamed Rice",
    detail: "Firm, separate grains that hold shape in buffets and catering lines.",
    specs: ["Low stickiness", "Consistent grain length", "10kg | 25kg catering packs"],
  },
  {
    title: "Special Blends",
    detail: "Custom blends for private labels, hotels, and supermarket house brands.",
    specs: ["Flavor-profiled blends", "Private label artwork support", "MOQ-based pricing"],
  },
];

const packaging = [
  "Consumer poly: 1kg | 5kg | 10kg",
  "Hotel and catering: 10kg | 25kg",
  "Woven PP sacks for export",
  "Custom private-label designs available",
];

const visualLineup = [
  { title: "Freshly milled white rice", src: whiteRiceImg },
  { title: "Golden harvest intake", src: harvestImg },
  { title: "Red raw and red samba", src: redRiceImg },
  { title: "Quality checks & grading", src: qaImg },
  { title: "Private-label packing line", src: packImg },
];

function Products() {
  return (
    <div className="page">
      <section className="page-hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="page-hero__content">
          <p className="eyebrow">Product range</p>
          <h1>Premium Sri Lankan rice for retail, food service, and export</h1>
          <p>
            Curated grains, consistent polish, and batch-level traceability - tuned for chefs, supermarkets, and
            distributors who demand reliability.
          </p>
          <div className="chip-row">
            <span className="chip">Samba & Nadu</span>
            <span className="chip">Keeri / Basmati</span>
            <span className="chip">Red raw</span>
            <span className="chip">Parboiled</span>
            <span className="chip">Private label</span>
          </div>
          <div className="hero__actions">
            <Link className="btn btn--primary" to="/contact">
              Request pricing
            </Link>
            <a className="btn btn--ghost" href="tel:+94771234567">
              Call sales
            </a>
          </div>
          <div className="stat-grid">
            <div className="stat">
              <strong>5</strong>
              <div>Packaging formats</div>
            </div>
            <div className="stat">
              <strong>48h</strong>
              <div>Average dispatch time</div>
            </div>
            <div className="stat">
              <strong>ISO</strong>
              <div>Clean-room packing</div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section__heading">
          <p className="eyebrow">Visual lineup</p>
          <h2>From harvest to polished grain</h2>
          <p className="muted">
            A glimpse of our grains and process - perfect for retail shelves, hotel kitchens, and export pallets.
          </p>
        </div>
        <div className="gallery-grid">
          {visualLineup.map((item) => (
            <div className="media-blend" key={item.title}>
              <img src={item.src} alt={item.title} />
              <div className="media-blend__text">{item.title}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="grid grid--3">
          {ranges.map((item) => (
            <div className="card product-card" key={item.title}>
              <div className="card__header">
                <h3>{item.title}</h3>
                <p>{item.detail}</p>
              </div>
              <ul className="pill-list">
                {item.specs.map((spec) => (
                  <li className="pill" key={spec}>
                    {spec}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--tint">
        <div className="section__split">
          <div>
            <p className="eyebrow">Packaging & labeling</p>
            <h2>Made for shelves and kitchens</h2>
            <ul className="checklist">
              {packaging.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
            <div className="ribbon">
              <strong>Need a private-label quote?</strong>
              <span>Share your monthly volume and we will respond within one business day.</span>
              <Link className="btn btn--secondary" to="/contact">
                Send enquiry
              </Link>
            </div>
          </div>
          <div className="image-card">
            <img src={packImg} alt="Packing line ready for dispatch" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;
